/**
 * 转场特效 - swipe
 * 2018-10-8
 */
(function (root, factory) {
  if (typeof module === 'object' && typeof module.exports === 'object') {
    module.exports = factory(this);
  } else {
      factory(root);
  }
})(this, function (root) {
  // 类构造函数
  function con(scene, option) {
    this.code = option.code || 'Swipe';
    this.maskEle = $('<div></div>').attr({ id: 'maskEle_' + scene.id });
    this.div1 = $('<div></div>');
    this.div2 = $('<div></div>');
    this.div3 = $('<div></div>');
  }

  var methods = {
    init: function (force) {
      this.duration = 1.5;
      this.startAt = 0.75;

      return this.supr(this.startAt, force).then(function () {
      })
    },

    initDom: function () {
      if (this.maskEle) {
        var _this = this,
          editor = this.scene.editor;

        this.div1.css({
          position: 'absolute',
          top: 0,
          right: 0,
          background: '#fff',
          width: 0,
          height: editor.clientHeight + 'px',
          opacity: 0.3
        });
        this.div2.css({
          position: 'absolute',
          top: 0,
          right: 0,
          background: '#fff',
          width: 0,
          height: editor.clientHeight + 'px',
          opacity: 0.3
        });
        this.div3.css({
          position: 'absolute',
          top: 0,
          right: 0,
          background: '#fff',
          width: 0,
          height: editor.clientHeight + 'px',
          opacity: 0.3
        });

        this.maskEle.css({
          width: editor.clientWidth + 'px',
          height: editor.clientHeight + 'px'
        }).append(this.div1).append(this.div2).append(this.div3).hide();

        // 插入播放层的 maskEle 中
        editor.player.maskEle.append(this.maskEle);
      }
    },

    show: function (frame) {
      // 播放
      if (!this.isInit) return;
      this.supr(frame);

      var scene = this.scene,
        editor = scene.editor,
        sEle = scene.element.player; // player层的当前 scene

      // 播放层显示，对应scene显示
      editor.player.ele.show();
      sEle.show();

      // 衔接上一个场景页的动画(e.g.前0.75s的动画)
      if (frame <= this.entrance.end) {
        this.showFirst(frame);
      }

      // 本场景页的转场动画(e.g.后0.75s的动画)
      if (this.nexts && frame >= this.exit.start) {
        // 隐藏上一个场景页的遮罩
        this.prevs && this.prevs.effect.maskEle && this.prevs.effect.maskEle.hide();

        var offFrame = frame - this.exit.start; // 当前帧减去动画开始时的帧
        if (offFrame <= 0.35 * this.frameRate) {
          this.div1.css({
            width: this.easeOutQuart(offFrame, 0, editor.clientWidth, 0.35*this.frameRate)
          });
        }
        if (offFrame <= 0.55 * this.frameRate) {
          this.div2.css({
            width: this.easeOutQuart(offFrame - 0.2 * this.frameRate, 0, editor.clientWidth, 0.35*this.frameRate)
          });
        }
        if (offFrame <= 0.75 * this.frameRate) {
          this.div3.css({
            width: this.easeOutQuart(offFrame - 0.4 * this.frameRate, 0, editor.clientWidth, 0.35*this.frameRate)
          });
        }

        this.maskEle.show();
      }

      // 动画外的时间
      if (frame > this.entrance.end && frame < this.exit.start) {
        this.showMiddle();
      }
    },

    // 为下一个场景提供方法以完成动画衔接
    showNext: function (frame) {
      var _currentFrame = this.startAt * this.frameRate + frame - 0.75 * this.frameRate,
          next_ele = this.nexts.element.player,
          height = this.scene.editor.clientHeight,
          width = this.scene.editor.clientWidth,
          changeWidth = this.linear(_currentFrame, width, -width, this.totalFrame / 2);

      this.maskEle.show();
      this.div1.css({ width: changeWidth });
      this.div2.css({ width: changeWidth });
      this.div3.css({ width: changeWidth });
      next_ele.css({
        'clip-path': 'polygon(0 0, ' + this.linear(_currentFrame, 0, width, this.totalFrame / 2) + 'px 0, ' + this.linear(_currentFrame, 0, width, this.totalFrame / 2) + 'px ' + height + 'px, 0 ' + height + 'px, 0 0)'
      }).show();
    },

    // 清空DOM,以及一些没必要对象
    clearMask: function () {
      this.maskEle.remove();
      this.maskEle = $('<div></div>').attr({id: 'maskEle_' + this.scene.id});
      this.isInit = false;
    }
  }

  // 静态方法
  var statics = {

  }

  if (root.AnimEditor) {
    root.AnimEditor.extendScenesEffect('Swipe', con, methods, statics);
    return;
  }

  return function (AnimEditor) {
    AnimEditor.extendScenesEffect('Swipe', con, methods, statics);
  }
});


//////////////////
// WEBPACK FOOTER
// ./static/animengine/js/scene-effects/se-swipe.js
// module id = fz7C
// module chunks = 16